export default __webpack_public_path__ + "static/claudia-e0f61967f445f10bf316c3977938df16.png";